const _identityVerify = `^[0-9a-zA-Z]{1,50}$`;
const _emailVerify = `^[a-zA-Z0-9.!#$%&'*+\\/=?^_\`{|}~-]+@[a-zA-Z0-9]
(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$`;
const _phoneVerify = `^1(3|4|5|6|7|8|9)\\d{9}$`;
const _landlinePhoneVerify = `(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^1(3|4|5|6|7|8|9)\\d{9}$)`;
const _carNumVerify = `^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$`;
const _numberVerify = `^\\d+$|^\\d*\\.\\d+$`;
const _nameEnVerify = `^[a-zA-Z1-9\\.\\s\\,\\(\\)\\-\\'\\&]{1,177}$`;
const _socialCodeVerify = `^[0-9A-Z]{18}$`;
const _socialCodeVerifyEn = `^[0-9a-zA-Z]+$`;
const _driverLicenseVerify = `^[0-9a-zA-Z]{1,32}$`;
const _registerCapitalVerify = `^(^[1-9](\\d+)?(\\.\\d{1,3})?$)|(^\\d\\.\\d{1,3}$)`;
const _twoPointVerify = `^(^[1-9](\\d+)?(\\.\\d{1,2})?$)|(^\\d\\.\\d{1,2}$)`;
const _commanderCodeVerify = `^[0-9]{1,10}$`;
const _dateVerify = `^\\d{4}-\\d{2}-\\d{2}$`;

// 身份证
export const identityVerify = new RegExp(_identityVerify.replace(/(\r\n)|(\n)/g, ''));

// 邮件
export const emailVerify = new RegExp(_emailVerify.replace(/(\r\n)|(\n)/g, ''));

// 联系电话
export const phoneVerify = new RegExp(_phoneVerify);

// 座机电话
export const landlinePhoneVerify = new RegExp(_landlinePhoneVerify);

// 车牌号
export const carNumVerify = new RegExp(_carNumVerify.replace(/(\r\n)|(\n)/g, ''));

// 数字
export const numberVerify = new RegExp(_numberVerify.replace(/(\r\n)|(\n)/g, ''));

// 英文名（公司名）
export const nameEnVerify = new RegExp(_nameEnVerify.replace(/(\r\n)|(\n)/g, ''));

// 统一社会信用代码/营业执照号/税务登记号
export const socialCodeVerify = new RegExp(_socialCodeVerify.replace(/(\r\n)|(\n)/g, ''));

// 统一社会信用代码/营业执照号/税务登记号（英文）
export const socialCodeVerifyEn = new RegExp(_socialCodeVerifyEn.replace(/(\r\n)|(\n)/g, ''));

// 驾驶证号
export const driverLicenseVerify = new RegExp(_driverLicenseVerify.replace(/(\r\n)|(\n)/g, ''));

// 注册资金 >0 保留三位小数
export const registerCapitalVerify = new RegExp(_registerCapitalVerify.replace(/(\r\n)|(\n)/g, ''));

// 车长、宽、高... >0 保留两位小数
export const twoPointVerify = new RegExp(_twoPointVerify.replace(/(\r\n)|(\n)/g, ''));

// 福佑车长代码
export const commanderCodeVerify = new RegExp(_commanderCodeVerify.replace(/(\r\n)|(\n)/g, ''));

// 日期 YYYY-MM-DD格式
export const dateVerify = new RegExp(_dateVerify.replace(/(\r\n)|(\n)/g, ''));